(function () {
  'use strict';
  if (window.MSPremiumNavigation) {
    window.MSPremiumNavigation.bind();
    return;
  }
  var current = null;
  function bind() {
  var navRoot = document.querySelector('[data-ms-premium-nav]');
  var drawerToggle = document.querySelector('[data-ms-premium-nav-toggle]');
  var drawer = document.querySelector('[data-ms-premium-nav-drawer]');
  var drawerBackdrop = document.querySelector('[data-ms-premium-nav-backdrop]');
  var bindingRoot = navRoot || drawer;
  if (current && current.root === bindingRoot && bindingRoot && bindingRoot.isConnected) return;
  if (current) { current.destroy(); current = null; }
  if (!bindingRoot) return;
  bindingRoot.setAttribute('data-ms-navigation-bound', 'true');

  var desktopQuery = window.matchMedia('(min-width: 1120px)');
  var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  var activeMegaItem = null;
  var megaCloseTimer = null;
  var drawerFocusFrame = null;
  var layoutFrame = null;
  var lastFocus = null;
  var lastDrawerFocus = null;
  var publishedMode = null;
  var wasDesktop = desktopQuery.matches;
  var MEGA_CLOSE_DELAY = 240;
  var listeners = [];
  var destroyed = false;
  function listen(target, type, handler, options) {
    target.addEventListener(type, handler, options);
    listeners.push(function () { target.removeEventListener(type, handler, options); });
  }

  function drawerIsOpen() { return !!drawer && !drawer.hidden; }
  function visible(element) {
    return !!element && element.isConnected && !element.hidden && element.getClientRects().length > 0;
  }
  function focusElement(element) {
    if (!visible(element) || typeof element.focus !== 'function') return false;
    element.focus({ preventScroll: true });
    return document.activeElement === element;
  }
  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
    )).filter(visible);
  }

  // Sticky-header integration: read the classes after this event.
  // detail: { open: Boolean, mode: 'desktop' | 'mobile' | null }.
  // Only the drawer is modal; desktop must not inherit modal overflow/chat rules.
  function publishState() {
    var mobileOpen = drawerIsOpen();
    var mode = mobileOpen ? 'mobile' : (activeMegaItem ? 'desktop' : null);
    document.body.classList.toggle('ms-premium-nav-open', mobileOpen);
    document.body.classList.toggle('ms-premium-mega-open', !!activeMegaItem);
    if (mode === publishedMode) return;
    publishedMode = mode;
    document.dispatchEvent(new CustomEvent('ms:navigation-change', {
      detail: { open: !!mode, mode: mode }
    }));
  }

  function measureMega() {
    layoutFrame = null;
    if (!activeMegaItem) return;
    var panel = activeMegaItem.querySelector('[data-ms-premium-nav-mega]');
    if (!panel) return;
    var viewport = window.visualViewport;
    var bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
    var available = Math.max(0, Math.floor(bottom - panel.getBoundingClientRect().top - 12));
    panel.style.setProperty('--ms-navigation-panel-height', available + 'px');
  }
  function requestMeasure() {
    if (layoutFrame !== null) window.cancelAnimationFrame(layoutFrame);
    layoutFrame = window.requestAnimationFrame(measureMega);
  }
  function cancelMegaClose() {
    window.clearTimeout(megaCloseTimer);
    megaCloseTimer = null;
  }
  function closeMega(options) {
    cancelMegaClose();
    if (!activeMegaItem) return;
    var item = activeMegaItem;
    var trigger = item.querySelector('[data-ms-premium-nav-trigger]');
    var panel = item.querySelector('[data-ms-premium-nav-mega]');
    item.classList.remove('is-open');
    item.removeAttribute('data-ms-premium-nav-click-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
    activeMegaItem = null;
    if (!options || options.publish !== false) publishState();
    if (options && options.restoreFocus) focusElement(trigger);
  }
  function openMega(item, source) {
    if (!item || !desktopQuery.matches || drawerIsOpen()) return;
    if (source === 'hover' && document.querySelector('.smart-search--header.is-search-open')) return;
    cancelMegaClose();
    if (activeMegaItem !== item) {
      var trigger = item.querySelector('[data-ms-premium-nav-trigger]');
      var panel = item.querySelector('[data-ms-premium-nav-mega]');
      if (!trigger || !panel) return;
      closeMega({ publish: false });
      activeMegaItem = item;
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }
    if (source === 'click' || source === 'keyboard') {
      item.setAttribute('data-ms-premium-nav-click-open', 'true');
    }
    publishState();
    measureMega();
    requestMeasure();
  }
  function scheduleMegaClose(item, fromFocus) {
    cancelMegaClose();
    megaCloseTimer = window.setTimeout(function () {
      if (activeMegaItem !== item || item.contains(document.activeElement)) return;
      if (!fromFocus && item.hasAttribute('data-ms-premium-nav-click-open')) return;
      closeMega();
    }, MEGA_CLOSE_DELAY);
  }

  function drawerFocusTarget() {
    if (lastDrawerFocus && drawer.contains(lastDrawerFocus) && visible(lastDrawerFocus)) return lastDrawerFocus;
    return drawer.querySelector('[data-ms-premium-nav-close]') || getFocusable(drawer)[0] || drawer;
  }
  function openDrawer() {
    if (!drawer || !drawerToggle || desktopQuery.matches || drawerIsOpen()) return;
    closeMega();
    lastFocus = document.activeElement;
    lastDrawerFocus = null;
    drawer.hidden = false;
    if (drawerBackdrop) drawerBackdrop.hidden = false;
    drawerToggle.setAttribute('aria-expanded', 'true');
    publishState();
    drawerFocusFrame = window.requestAnimationFrame(function () {
      drawerFocusFrame = null;
      if (drawerIsOpen()) focusElement(drawerFocusTarget());
    });
  }
  function closeDrawer(options) {
    if (drawerFocusFrame !== null) window.cancelAnimationFrame(drawerFocusFrame);
    drawerFocusFrame = null;
    if (!drawerIsOpen()) return;
    var focusWasInside = drawer.contains(document.activeElement);
    drawer.hidden = true;
    if (drawerBackdrop) drawerBackdrop.hidden = true;
    if (drawerToggle) drawerToggle.setAttribute('aria-expanded', 'false');
    publishState();
    if (!options || options.restoreFocus !== false) {
      if (!focusElement(lastFocus)) focusElement(drawerToggle);
    } else if (options.breakpoint && focusWasInside && navRoot) {
      focusElement(navRoot.querySelector('[data-ms-premium-nav-trigger]'));
    }
    lastDrawerFocus = null;
  }
  function trapDrawerFocus(event) {
    if (!drawerIsOpen() || event.key !== 'Tab') return;
    var elements = getFocusable(drawer);
    var first = elements[0];
    var last = elements[elements.length - 1];
    if (!elements.length) {
      event.preventDefault();
      focusElement(drawer);
    } else if (!drawer.contains(document.activeElement) || document.activeElement === drawer) {
      event.preventDefault();
      focusElement(event.shiftKey ? last : first);
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      focusElement(last);
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      focusElement(first);
    }
  }

  if (navRoot) Array.prototype.forEach.call(navRoot.querySelectorAll('[data-ms-premium-nav-item]'), function (item) {
    var trigger = item.querySelector('[data-ms-premium-nav-trigger]');
    var panel = item.querySelector('[data-ms-premium-nav-mega]');
    if (!trigger || !panel) return;
    listen(trigger, 'mouseenter', function () {
      if (hoverQuery.matches) openMega(item, 'hover');
    });
    // Plain focus does not open: Escape can return to the trigger reliably.
    listen(trigger, 'click', function () {
      if (activeMegaItem === item && item.hasAttribute('data-ms-premium-nav-click-open')) closeMega();
      else openMega(item, 'click');
    });
    listen(trigger, 'keydown', function (event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      event.preventDefault();
      openMega(item, 'keyboard');
      var elements = getFocusable(panel);
      focusElement(event.key === 'ArrowUp' ? elements[elements.length - 1] : elements[0]);
    });
    listen(item, 'mouseenter', cancelMegaClose);
    listen(item, 'mouseleave', function () { scheduleMegaClose(item, false); });
    listen(item, 'focusin', cancelMegaClose);
    listen(item, 'focusout', function () { scheduleMegaClose(item, true); });
  });

  if (drawerToggle) listen(drawerToggle, 'click', function () {
    if (drawerIsOpen()) closeDrawer();
    else openDrawer();
  });
  if (drawerBackdrop) listen(drawerBackdrop, 'click', function () { closeDrawer(); });
  Array.prototype.forEach.call(document.querySelectorAll('[data-ms-premium-nav-close]'), function (button) {
    listen(button, 'click', function () { closeDrawer(); });
  });
  listen(document, 'focusin', function (event) {
    if (!drawerIsOpen()) return;
    if (drawer.contains(event.target)) lastDrawerFocus = event.target;
    else focusElement(drawerFocusTarget());
  });
  listen(document, 'keydown', function (event) {
    if (event.defaultPrevented) return;
    if (event.key === 'Escape') {
      if (drawerIsOpen()) {
        event.preventDefault();
        closeDrawer();
      } else if (activeMegaItem) {
        event.preventDefault();
        closeMega({ restoreFocus: activeMegaItem.contains(document.activeElement) });
      }
    }
    trapDrawerFocus(event);
  });
  listen(document, 'click', function (event) {
    if (activeMegaItem && navRoot && !navRoot.contains(event.target)) closeMega();
  });
  listen(document, 'ms:search-open', function () { closeMega(); });

  function onViewportChange() {
    var isDesktop = desktopQuery.matches;
    if (isDesktop !== wasDesktop) {
      if (isDesktop) closeDrawer({ restoreFocus: false, breakpoint: true });
      else if (activeMegaItem) {
        var restore = activeMegaItem.contains(document.activeElement);
        closeMega();
        if (restore) focusElement(drawerToggle);
      }
      wasDesktop = isDesktop;
    }
    requestMeasure();
  }
  listen(window, 'resize', onViewportChange);
  if (desktopQuery.addEventListener) listen(desktopQuery, 'change', onViewportChange);
  else if (desktopQuery.addListener) {
    desktopQuery.addListener(onViewportChange);
    listeners.push(function () { desktopQuery.removeListener(onViewportChange); });
  }
  if (window.visualViewport) {
    listen(window.visualViewport, 'resize', requestMeasure);
    listen(window.visualViewport, 'scroll', requestMeasure);
  }
  current = {
    root: bindingRoot,
    destroy: function () {
      if (destroyed) return;
      destroyed = true;
      closeDrawer({ restoreFocus: false });
      closeMega();
      cancelMegaClose();
      if (drawerFocusFrame !== null) window.cancelAnimationFrame(drawerFocusFrame);
      if (layoutFrame !== null) window.cancelAnimationFrame(layoutFrame);
      listeners.forEach(function (remove) { remove(); });
      bindingRoot.removeAttribute('data-ms-navigation-bound');
    }
  };
  }
  function unload(root) {
    if (current && (root === current.root || root.contains(current.root))) {
      current.destroy();
      current = null;
    }
  }
  window.MSPremiumNavigation = { bind: bind };
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', function (event) { unload(event.target); });
  bind();
})();
